import { useFormattedSites } from '@app/ccf/company-report/utils';
import { useGetSites } from '@shared/api';
import { FormProps } from '@shared/components/form/types';
import { MultiSelect } from '@shared/components/multi-select';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@shared/components/ui/form';
import { cn } from '@shared/lib/utils';
import { useFormContext } from 'react-hook-form';

interface MultiSitesPickerProps extends FormProps {}

function MultiSitesPicker({
  name,
  className,
  label,
  includeErrorMessage,
  ...props
}: MultiSitesPickerProps) {
  const { control, setValue } = useFormContext();

  const { data: sites, isLoading: isSitesLoading } = useGetSites({
    page: 1,
    page_size: 1000,
  });

  const formattedSites = useFormattedSites(sites?.results || []);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <FormItem className={cn('grid flex-1 items-center', className)}>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <MultiSelect
                options={formattedSites}
                itemName="site"
                isLoading={isSitesLoading}
                onValueChange={field.onChange}
                defaultValue={field.value}
                placeholder={
                  formattedSites.length > 0
                    ? 'All sites included'
                    : 'No sites added'
                }
                disabled={formattedSites.length === 0}
                className="bg-gray-00"
                autoSize
                responsive
                hideSelectAll
                popoverClassName="max-w-sm"
              />
            </FormControl>
            {includeErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
    />
  );
}

export default MultiSitesPicker;
